import React from 'react';

const EuropeanUnion = (props: { width: number }) => {
  return (
    <svg viewBox="0 0 810 540" {...props}>
      <title>European Union Flag</title>
      <defs>
        <g id="eu-d">
          <g id="eu-b">
            <path d="M0 0v1h.5z" id="eu-a" transform="rotate(18 3.157 -.5)" />
            <use transform="scale(-1 1)" xlinkHref="#eu-a" />
          </g>
          <g id="eu-c">
            <use transform="rotate(72)" xlinkHref="#eu-b" />
            <use transform="rotate(144)" xlinkHref="#eu-b" />
          </g>
          <use transform="scale(-1 1)" xlinkHref="#eu-c" />
        </g>
      </defs>
      <path d="M0 0h810v540H0z" fill="#039" />
      <g fill="#fc0" transform="matrix(30 0 0 30 405 270)">
        <use xlinkHref="#eu-d" y="-6" />
        <use xlinkHref="#eu-d" y="6" />
        <g id="eu-e">
          <use x="-6" xlinkHref="#eu-d" />
          <use transform="rotate(-144 -2.344 -2.11)" xlinkHref="#eu-d" />
          <use transform="rotate(144 -2.11 -2.344)" xlinkHref="#eu-d" />
          <use transform="rotate(72 -4.663 -2.076)" xlinkHref="#eu-d" />
          <use transform="rotate(72 -5.076 .534)" xlinkHref="#eu-d" />
        </g>
        <use transform="scale(-1 1)" xlinkHref="#eu-e" />
      </g>
    </svg>
  );
};

export default EuropeanUnion;
